"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewMsgFromWsAndLook = exports.updateNewNoticeListFromWs = exports.delUnReadNoticeList = exports.updateUnReadNoticeList = exports.updateReadNoticeList = exports.updateReadMsgCount = exports.updateUnReadMsgCount = void 0;
const actions = __importStar(require("../../../shared/store/action_constants"));
/**
 * update unread notification count
 * @param count
 * @returns
 */
const updateUnReadMsgCount = (count) => {
    return {
        type: actions.UPDATE_UNREAD_MSG_COUNT,
        payload: count,
    };
};
exports.updateUnReadMsgCount = updateUnReadMsgCount;
const updateReadMsgCount = (count) => {
    return {
        type: actions.UPDATE_READ_MSG_COUNT,
        payload: count,
    };
};
exports.updateReadMsgCount = updateReadMsgCount;
/**
 * update notification that have read
 * @param list
 * @param unshift
 * @param push
 * @param updateCount
 * @returns
 */
const updateReadNoticeList = (list, unshift, push, updateCount) => {
    return {
        type: actions.UPDATE_READ_NOTICE_LIST,
        payload: { list, unshift, push, updateCount },
    };
};
exports.updateReadNoticeList = updateReadNoticeList;
const updateUnReadNoticeList = (list, unshift, push, updateCount) => {
    return {
        type: actions.UPDATE_UNREAD_NOTICE_LIST,
        payload: { list, unshift, push, updateCount },
    };
};
exports.updateUnReadNoticeList = updateUnReadNoticeList;
const delUnReadNoticeList = (idList, isAll) => {
    return {
        type: actions.DEL_UNREAD_NOTICE_LIST,
        payload: { idList, isAll },
    };
};
exports.delUnReadNoticeList = delUnReadNoticeList;
const updateNewNoticeListFromWs = (notice) => {
    return {
        type: actions.UPDATE_NEW_NOTICE_LIST_FROM_WS,
        payload: notice,
    };
};
exports.updateNewNoticeListFromWs = updateNewNoticeListFromWs;
const getNewMsgFromWsAndLook = (inNotice) => {
    return {
        type: actions.GET_NEW_MSG_FROM_WS_AND_LOOK,
        payload: inNotice,
    };
};
exports.getNewMsgFromWsAndLook = getNewMsgFromWsAndLook;
//# sourceMappingURL=notification.js.map